// @flow
import {List} from 'immutable';
import {Store} from 'client/framework';
import appStore from 'client/AppStore';
import teacherClassroomScopeStore from 'client/Classrooms/Classroom/Teacher/TeacherClassroomScope/TeacherClassroomScope.store';
import {getTopicQuery} from '../Topics.query.js';
import type {QueryBuilder} from '@albert-io/json-api-framework/request/builder/legacy';
import type {GuideLevelV2} from 'resources/GuideLevel/GuideLevelV2.model';

export default class ToughestTopicsStore extends Store {
  _getTopicsQuery(): QueryBuilder {
    const attemptNumber = teacherClassroomScopeStore.getAttemptNumber();
    const selectedSubjects = teacherClassroomScopeStore.getSelectedSubjects();

    const query = getTopicQuery({
      studentId: appStore.routerProps.params.userId,
      attemptNumber: attemptNumber,
      selectedSubjects: selectedSubjects,
      startDate: teacherClassroomScopeStore.getStartDate(),
      endDate: teacherClassroomScopeStore.getEndDate()
    });
    return query
      .customQuery({
        sort: 'meta.student_accuracy',
        with_meta: 'guide_level_v2'
      });
  }

  hasReceivedTopics(): boolean {
    return this._getTopicsQuery().isResourceReady();
  }

  getTopics(): List<GuideLevelV2> {
    return this._getTopicsQuery().getResource().getCollection().take(3);
  }
}
